import MainRouter from "@/router";

import localRoutes from "./router";

MainRouter.addRoutes(localRoutes);